import React from 'react';
import { Trans } from 'react-i18next';

const AdditionalTerms = ({ loanObject = {} }) => {
	if (loanObject && loanObject.additional_terms) {
		const ADDITIONAL_TERMS = loanObject.additional_terms;
		return (
			<>
				<p className="justify">
					<Trans i18nKey="loan_agreement.additional_terms_and_conditions">
						<strong style={{ marginRight: '2px' }}>ADDITIONAL TERMS AND CONDITION. </strong>The Loan shall
						also be subject to the following additional terms and conditions agreed by both parties:
					</Trans>
				</p>
				<p>
					<Trans i18nKey="loan_agreement.additional_terms_and_condtions_details">
						{{ ADDITIONAL_TERMS }}
					</Trans>
				</p>
			</>
		);
	}

	return null;
};

export default AdditionalTerms;
